import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable()
export class CheckForUpdateService {

  constructor(appRef: ApplicationRef, updates: SwUpdate) {
    if (location.protocol === 'https:') {
      // Allow the app to stabilize first, before starting polling for updates with `interval()`.
      const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
      const everyOneHours$ = interval(1 * 1 * 60 * 1000);
      const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everyOneHours$);
      
      everySixHoursOnceAppIsStable$.subscribe((event) => {
        console.log('event', event);
        const isUpdateAvailable = updates.checkForUpdate();
        console.log('isUpdateAvailable', isUpdateAvailable);
        return isUpdateAvailable;
      });
    }
  }
}